import { combineReducers } from 'redux';
import { installStatus } from './InstallStatus/reducer';

export const fbeIntegration = combineReducers({
  installStatus,
});
